import {
  query,
  addDoc,
  orderBy,
  getDocs,
  collection,
} from "firebase/firestore";

import { db } from "configs";
import { Utils } from "utils";
import { COLLECTIONS } from "constants/firebase";
import {
  Iterable,
  IPublicKey,
  IGraphhopperHit,
  IGraphhopperRoute,
} from "types";

import { graphhopperInstance } from "./instances";

const graphhopperApiKeys = JSON.parse(
  process.env.REACT_APP_GRAPHHOPPER_API_KEYS!
) as string[];
const API_KEY = graphhopperApiKeys[0];

const searchParams = new URLSearchParams({
  key: API_KEY,
}).toString();

export const buildRoute = async ({
  avoid,
  points,
  optimize = true,
}: {
  avoid?: string[];
  optimize?: boolean;
  points: number[][];
  withAlternativeRoads?: boolean;
}) => {
  try {
    const payload: { [key: string]: any } = {
      points: points,
      vehicle: "car",
      // timeout_ms: 60000,
      points_encoded: false,
      details: ["country", "curvature", "distance", "toll"],
    };

    // if (withAlternativeRoads) {
    //   payload["ch.disable"] = true;
    //   payload.algorithm = "alternative_route";
    // }

    if (avoid && avoid.length > 0) {
      payload["ch.disable"] = true;
      payload.custom_model = {
        priority: avoid.map((item) => {
          let condition = "";
          let multiplier = 0.1;

          if (item === "MOTORWAY" || item === "TRUNK") {
            condition = `road_class == ${item}`;
          }

          if (
            item === "ROAD" ||
            item === "FERRY" ||
            item === "BRIDGE" ||
            item === "TUNNEL"
          ) {
            condition = `road_environment == ${item}`;
          }

          if (item === "TOLL") {
            condition = "toll == ALL || toll == HGV";
            multiplier = 0.1;
          }

          return { if: condition, multiply_by: multiplier };
        }),
      };
    }

    if (optimize && !payload["ch.disable"]) {
      payload.optimize = "true";
    }

    const response = await graphhopperInstance.post<IGraphhopperRoute>(
      `https://graphhopper.com/api/1/route?${searchParams}`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const search = (queryString: string) => {
  const q = new URLSearchParams({
    q: queryString,
    limit: "10",
    key: API_KEY,
    locale: "en",
    reverse: "false",
    provider: "default",
  }).toString();

  return graphhopperInstance.get<{ hits: IGraphhopperHit[] }>(`/geocode?${q}`);
};

export const geocode = (lat: number, lng: number) => {
  const q = new URLSearchParams({
    // q: q,
    limit: "10",
    key: API_KEY,
    locale: "en",
    reverse: "true",
    provider: "default",
    point: `${lat},${lng}`,
  }).toString();

  return graphhopperInstance.get<{
    hits: IGraphhopperHit[];
  }>(`/geocode?${q}`);
};

export const keys = {
  list: async () => {
    const coll = collection(db, COLLECTIONS.GRAPHHOPER_KEYS);
    const q = query(coll, orderBy("createdAt", "asc"));

    const documents = await getDocs(q);
    const keys = Utils.Helpers.castDocs<Iterable<IPublicKey>>(documents);

    return keys;
  },

  create: async (data: IPublicKey) => {
    const coll = collection(db, COLLECTIONS.GRAPHHOPER_KEYS);
    return addDoc(coll, data);
  },
};
